import { Injectable, Injector } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { RSFSettingsCreate, RSFSettingsDelete, RSFSettingsRefresh, RSFSettingsRefreshById, RSFSettingsUpdate } from './rsf-settings.action';
import { BaseState } from 'src/app/common/base/base.state';
import { RSFSettings } from '../rsf-settings';
import { RsfSettingsService } from '../rsf-settings.service';


export class RSFSettingsStateModel {
  data: RSFSettings[] = [];
}

@State<RSFSettingsStateModel>({
  name: 'RSFSettings',
  defaults: {
    data: []
  }
})
@Injectable()
export class RSFSettingsState extends BaseState {
  constructor(
    protected override injector: Injector,
    private _service: RsfSettingsService
  ) { super(injector); }

  @Selector()
  static read(state: RSFSettingsStateModel) {
    return state.data;
  }

  @Action(RSFSettingsRefresh)
  refresh({ patchState }: StateContext<RSFSettingsStateModel>) {
    this._service.getAll().subscribe(
      data => patchState({ data }),
      error => console.error(error)
    );
  }

  @Action(RSFSettingsRefreshById)
  refreshById({ getState, patchState }: StateContext<RSFSettingsStateModel>, { id }: RSFSettingsRefreshById) {
    this._service.getById(id).subscribe(
      data => {
        const state = getState();
        const index = state.data.map(x => x.id).indexOf(data.id);
        if (index >= 0) {
          state.data.splice(index, 1);
        }
        patchState({
          data: [...getState().data, data]
        });
      },
      error => console.error(error)
    );
  }

  @Action(RSFSettingsCreate)
  create({ getState, patchState }: StateContext<RSFSettingsStateModel>, { item }: RSFSettingsCreate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(item.id);
    if (index >= 0) {
      state.data.splice(index, 1);
    }
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(RSFSettingsUpdate)
  update({ getState, patchState }: StateContext<RSFSettingsStateModel>, { id, item }: RSFSettingsUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
      patchState({
        data: [...state.data, item]
      });
    }
  }

  @Action(RSFSettingsDelete)
  delete({ getState, patchState }: StateContext<RSFSettingsStateModel>, { id }: RSFSettingsDelete) {
    patchState({
      data: getState().data.filter(x => x.id !== id)
    });
  }

}
